import { SettingsContainer } from './SettingsContainer';

const name = 'SettingsContainer';

export { name, SettingsContainer };
